module.exports = __webpack_public_path__ + "img/varitop.4b3765e1.jpg";